import { DisplaySchedule, Schedule } from './types';

export const formatTimeString = (time?: string) => {
  return time?.slice(0, 5) || '';
};

export const getDefaultSchedule = (): DisplaySchedule[] => {
  return [
    {
      breaks: [],
      startTime: '09:00',
      endTime: '17:00',
    },
  ];
};

export const defaultSchedule: Schedule = {
  monday: getDefaultSchedule(),
  tuesday: getDefaultSchedule(),
  wednesday: getDefaultSchedule(),
  thursday: getDefaultSchedule(),
  friday: getDefaultSchedule(),
  sunday: [],
  saturday: [],
};
